<template>
	<span>
		<span v-if="display">
			<v-text-field :hint="hint" :value="display(model)" :disabled="true" :label="label"></v-text-field>
		</span>
		<span :title="model" v-if="!display">
			<v-text-field
				v-model="model"
				@input="update()"
				:disabled="inputDisabled"
				:label="label"
				persistent-hint
				:hint="hint"
				:rules="computedRules"
			></v-text-field>
		</span>
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	props: ['display'],
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/textInput.vue